import { Box, Flex, Grid, Image } from '@chakra-ui/react';

import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';
import { TextareaField } from 'src/components/common/inputs/InputField/textareaField';
import ZoomGameMockUp from '../../ZoomGameMockUp/zoomGameMockUp';

export const SetDescription = () => {
	const { values } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.setDescription.label')} description={t('form.steps.setDescription.description')}>
					{t('form.steps.setDescription.heading')}
				</FormSectionHeading>

				<TextareaField
					label={t('form.fields.description')}
					name="description"
					placeholder={t('form.steps.setDescription.placeholder')}
				/>
			</LeftColumn>
			<RightColumn>
				<ZoomGameMockUp
					zoom={{ x: 0, y: 370, width: 400, height: Number('370') }}
					ctaColor={(values as any).colors.actionColor}
					textColor={(values as any).colors.textColor}
					bgColor={(values as any).colors.backgroundColor}
					video={(values as any).video}
					screenshots={(values as any).screenshots}
					description={(values as any).description != '' ? (values as any).description : 'Description...'}
					name={(values as any).name}
				/>
			</RightColumn>
		</TwoColumn>
	);
};
